import { FETCH_PACKAGE_ORDER_LIST_FULFILLED } from 'constants/kapidaConstants/packageOrderList';
import { FETCH_PACKAGE_ORDER_DETAIL_FULFILLED } from 'constants/kapidaConstants/packageOrderDetail';
import { FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED } from 'constants/kapidaConstants/packageDeliveryRanges';
import { FETCH_TRANSFER_ORDER_LIST_FULFILLED } from 'constants/kapidaConstants/transferOrderList';
import { FETCH_TRANSFER_ORDER_DETAIL_FULFILLED } from 'constants/kapidaConstants/transferOrderDetail';
import { FETCH_SIGNUP_REJECTED } from 'constants/kapidaConstants/signup';
import {
  SIGNIN_SMS_VERIFICATION_FORM_SHOW,
  FETCH_SMS_REJECTED,
  SIGNIN_SMS_VERIFICATION_REJECTED,
} from 'constants/kapidaConstants/signinWithSms';
import { FETCH_CARGO_COMPANIES_FULFILLED } from 'constants/kapidaConstants/cargoCompanies';
import { FETCH_PERMISSIONS_FULFILLED } from 'constants/kapidaConstants/permissions';

import { packageOrderListMapper } from 'models/kapidaModels/packageOrderList';
import { packageOrderDetailMapper } from 'models/kapidaModels/packageOrderDetail';
import { packageDeliveryRangesMapper } from 'models/kapidaModels/packageDeliveryRanges';
import { transferOrderListMapper } from 'models/kapidaModels/transferOrderList';
import { transferOrderDetailMapper } from 'models/kapidaModels/transferOrderDetail';
import { signupRejectedMapper } from 'models/kapidaModels/signupRejected';
import { signInSmsVerificationMapper } from 'models/kapidaModels/signInSmsVerification';
import { signInSmsRejectedMapper } from 'models/kapidaModels/signInSmsRejected';
import { signInSmsVerficiationRejectedMapper } from 'models/kapidaModels/signInSmsVerificationRejected';
import { cargoCompaniesMapper } from 'models/kapidaModels/cargoCompanies';
import { permissionsMapper } from 'models/kapidaModels/permissions';

export default class Mappers {
  constructor() {
    this.bindToModel = this.bindToModel.bind(this);
    this.map = {
      [FETCH_PACKAGE_ORDER_LIST_FULFILLED]: packageOrderListMapper,
      [FETCH_PACKAGE_ORDER_DETAIL_FULFILLED]: packageOrderDetailMapper,
      [FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED]: packageDeliveryRangesMapper,
      [FETCH_TRANSFER_ORDER_LIST_FULFILLED]: transferOrderListMapper,
      [FETCH_TRANSFER_ORDER_DETAIL_FULFILLED]: transferOrderDetailMapper,
      [FETCH_SIGNUP_REJECTED]: signupRejectedMapper,
      [SIGNIN_SMS_VERIFICATION_FORM_SHOW]: signInSmsVerificationMapper,
      [SIGNIN_SMS_VERIFICATION_REJECTED]: signInSmsVerficiationRejectedMapper,
      [FETCH_SMS_REJECTED]: signInSmsRejectedMapper,
      [FETCH_CARGO_COMPANIES_FULFILLED]: cargoCompaniesMapper,
      [FETCH_PERMISSIONS_FULFILLED]: permissionsMapper,
    };
  }

  bindToModel(action) {
    const { map } = this;
    const mapper = map[action.type];
    return mapper
      ? {
          ...action,
          data: mapper(action.data),
        }
      : action;
  }
}



// WEBPACK FOOTER //
// ./src/services/kapidaIntegration/index.js